import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function AuthImage({ fileId, alt, className, onClick, ...rest }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    let active = true;
    api.get(`/files/${fileId}`, { responseType: "blob" })
      .then((r) => {
        if (!active) return;
        url = URL.createObjectURL(r.data);
        setSrc(url);
      })
      .catch(() => {});
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [fileId]);

  if (!src)
    return <div className={`bg-slate-100 animate-pulse ${className}`} />;
  return <img src={src} alt={alt || "foto"} className={className} onClick={onClick} {...rest} />;
}
